module.exports = __webpack_public_path__ + "h5/img/bn.5e678720.png";